// src/components/shared/InfoChip.js
// Pill de informação narrativa (manejo, dosagem, hormônio) em PageInfoStrip.

import React from 'react'
import { Box, Typography } from '@mui/material'

export default function InfoChip({ icon, label, value }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        bgcolor: 'background.default',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 999,
        px: 1.75,
        py: 0.625,
        fontSize: '0.875rem',
        whiteSpace: 'nowrap',
      }}
    >
      {icon && <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>{icon}</Box>}
      {label && (
        <Typography
          component="span"
          sx={{ fontWeight: 600, color: 'text.primary', fontSize: 'inherit' }}
        >
          {label}:
        </Typography>
      )}
      <Typography
        component="span"
        sx={{ color: 'text.secondary', fontSize: 'inherit' }}
      >
        {value}
      </Typography>
    </Box>
  )
}
